import { Box, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";
import FileList from "./fileList";
import { isWidgetReadOnly } from "../helpers/formReadOnly";

const SectionCertificateUpload = ({
  form,
  name,
  readOnly = false,
  disabled = false,
  readonly = false,
}) => {
  const { t } = useTranslation();
  const locked = isWidgetReadOnly({ disabled, readOnly, readonly, form });

  return (
    <Box
      mt="lg"
      pt="md"
      sx={(theme) => ({
        borderTop: `1px solid ${theme.colors.gray[2]}`,
      })}
    >
      <Text size="sm" weight={600} mb="xs">
        {t("Certificate files")}
      </Text>
      <FileList
        compact
        form={form}
        name={name}
        disabled={locked}
        uploadLabel="Drop PDF or image, or click to browse"
        showNoFilesMessage={false}
      />
    </Box>
  );
};

export default SectionCertificateUpload;
